/** Grymwyrd 한국어 공유 레이아웃(상단 네비게이션 + 하단 정보) 복사본입니다. */
export const layoutKo = {
  'layout.nav.veil': '장막',
  'layout.nav.encyclopedia': '백과사전',
  'layout.nav.world': '세계',
  'layout.nav.play': '플레이',
  'layout.nav.books': '규칙서 및 보충서',
  'layout.nav.community': '커뮤니티',
  'layout.nav.homeAria': '{world} 홈',
  'layout.nav.search': '백과사전 검색',
  'layout.nav.unmute': '분위기 음소거 해제',
  'layout.nav.mute': '분위기 음소거',
  'layout.nav.coinBalance': '코인 잔액',
  'layout.nav.signedInAs': '{name}로 로그인됨',
  'layout.nav.enter': '{world} 입장',
  'layout.nav.toggleMenu': '메뉴 토글',
  'layout.nav.dashboard': '내 {world} ({name})',
  'layout.nav.signOut': '로그아웃',

  'layout.footer.hideLinks': '사이트 링크 숨기기',
  'layout.footer.showLinks': '사이트 링크 및 법적 정보',
  'layout.footer.tagline': '당신의 전설이 정사가 되는 살아있는 공포-판타지 세계입니다.',
  'layout.footer.explore': '탐험',
  'layout.footer.legal': '법적 정보',
  'layout.footer.accessibility': '접근성',
  'layout.footer.encyclopedia': '백과사전',
  'layout.footer.world': '세계',
  'layout.footer.playVtt': '플레이 (VTT)',
  'layout.footer.books': '규칙서 및 보충서',
  'layout.footer.terms': '이용약관',
  'layout.footer.privacy': '개인정보보호정책',
  'layout.footer.canonRelease': '정사 제출 라이선스',
  'layout.footer.aiPolicy': 'AI 정책',
  'layout.footer.cookies': '쿠키 설정',
  'layout.footer.copyright': '© 2026 GameCodex',
}
